export const TIME_TO_WAIT_FOR_TRANSFER_FAIL_MS = 5000;
